class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }
  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => { event.preventDefault(); this.open(cartLink); });
    cartLink.addEventListener('keydown', (event) => { if (event.code.toUpperCase() === 'SPACE') { event.preventDefault(); this.open(cartLink); } });
  }
  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => { this.classList.add('animate', 'active'); window.loadLuxCartPairings?.(); });
    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });
    document.body.classList.add('overflow-hidden');
  }
  close() { this.classList.remove('active'); removeTrapFocus(this.activeElement); document.body.classList.remove('overflow-hidden'); }
  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');
    if (cartDrawerNote.nextElementSibling.getAttribute('id')) cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    cartDrawerNote.addEventListener('click', (event) => { event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open')); });
    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }
  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });
    setTimeout(() => { this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this)); this.open(); window.loadLuxCartPairings?.(); });
  }
  getSectionInnerHTML(html, selector = '.shopify-section') { return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML; }
  getSectionsToRender() { return [{ id: 'cart-drawer', selector: '#CartDrawer' }, { id: 'cart-icon-bubble' }]; }
  getSectionDOM(html, selector = '.shopify-section') { return new DOMParser().parseFromString(html, 'text/html').querySelector(selector); }
  setActiveElement(element) { this.activeElement = element; }
}
customElements.define('cart-drawer', CartDrawer);
class CartDrawerItems extends CartItems { getSectionsToRender() { return [{ id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' }, { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }]; } }
customElements.define('cart-drawer-items', CartDrawerItems);
(() => {
  const source = document.currentScript?.src;
  if (!source) return;
  const load = (file, attr) => {
    if (document.querySelector(`link[${attr}]`)) return;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = new URL(file, source).href;
    link.setAttribute(attr, 'true');
    document.head.appendChild(link);
  };
  const loadScript = (file, attr) => {
    if (document.querySelector(`script[${attr}]`)) return;
    const loader = document.createElement('script');
    loader.src = new URL(file, source).href;
    loader.defer = true;
    loader.setAttribute(attr, 'true');
    document.head.appendChild(loader);
  };
  load('lux-global-theme.css', 'data-lux-global-theme');
  load('lux-mobile-final.css', 'data-lux-mobile-final');
  loadScript('lux-cart-pairings.js', 'data-lux-cart-pairings');
  loadScript('lux-checkout-offer.js', 'data-lux-checkout-offer');
})();